import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ReactTabulator } from 'react-tabulator';
import { CSVLink } from 'react-csv';
import DatePicker from "react-datepicker";
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import loader from '../../assets/img/loading.gif'
// import { useDispatch, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { API_BASE_URL } from '../../config/app-axios.jsx';
import API from '../../api/api.jsx';
import { jwtDecode } from 'jwt-decode';
import { clearUserState } from '../../reducers/userReducers.jsx';
import { clearMenuState } from '../../reducers/menuReducers.jsx';
import { clearLangCodeState } from '../../reducers/langCodeReducers.jsx';
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from '../../store.jsx';

// Tabulator columns 목록
const initializeColumns = (t, loanDateFieldName, loanReceivableIdFieldName, customerNameFieldName, collateralType, expiredDateFieldName, loanAmountFieldName, balanceFieldName, branchFieldName, statusFieldName, overdueDays) => {
	return [
		{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
			cell.getRow().toggleSelect();
		}},
		{ title: loanDateFieldName, field: 'loan_disbursement_date', headerHozAlign: 'center', hozAlign: 'center', width:180, formatter:function(cell, formatterParams, onRendered){
			var value = cell.getValue();

			if (!value) {
				return '';
			}

			value = moment(value).format("DD/MM/YYYY");
			return value;
		} },
		// { title: `<i class="fa-solid fa-link"></i> ${loanReceivableIdFieldName}`, field: 'loan_receivable_id', headerHozAlign: 'center', hozAlign: 'center', width:200, 
		// 	formatterParams:{
		// 		urlPrefix:"/bond/detail/loanReceivableId=", // URL 커스텀
		// 	},
		// 	formatter: function(cell, formatterParams, onRendered){
		// 		let value = cell.getValue();
		// 		let href  = `${formatterParams["urlPrefix"]}${value}`;
		// 		value = value.slice(0, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9, 15) + '-' + value.slice(15);
	
		// 		return `<a href="${href}" style="text-decoration: none; font-weight: bold; color: green;">${value}</a>`
		// 	}
		// },
	{ 
		title: `<i class="fa-solid fa-link"></i> ${loanReceivableIdFieldName}`, 
		field: 'loan_receivable_id', 
		headerHozAlign: 'center', 
		hozAlign: 'center', 
		width:200, 
		formatter: function(cell){
			let value = cell.getValue();
			let displayValue = value.slice(0, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9, 15) + '-' + value.slice(15);

			return `<span style="cursor:pointer; font-weight:bold; color:green; text-decoration:underline;">${displayValue}</span>`;
		},
		cellClick: function(e, cell) {
			const value = cell.getValue();
			// App 레이아웃 없는 standalone 페이지 열기
			const url = `/bond/bond_002_01?loanReceivableId=${value}`;
			const width = 1200;
			const height = 800;

			// 화면 크기 가져오기
			const screenWidth = window.screen.width;
			const screenHeight = window.screen.height;

			// 가운데 위치 계산
			const left = (screenWidth - width) / 2;
			const top = (screenHeight - height) / 2;

			// 팝업 열기
			window.open(
				url,
				"_blank",
				`width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
			);
		}
	},
		{ title: customerNameFieldName, field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:160, 
			formatter:function (cell, formatterParams, onRendered) {
				cell.getElement().style.fontWeight = 'bold';
				return cell.getValue();
			}
		},
		{ title: collateralType, field: 'collateral_type', headerHozAlign: 'center', hozAlign: 'center', width:160},  
		{ title: expiredDateFieldName, field: 'expired_date', headerHozAlign: 'center', hozAlign: 'center', width:180, formatter:function(cell, formatterParams, onRendered){
			var value = cell.getValue();

			if (!value) {
				return '';
			}

			value = moment(value).format("DD/MM/YYYY");
			return value;
		} },
		{ title: loanAmountFieldName, field: 'loan_amount', headerHozAlign: 'center', hozAlign: 'right', width:150, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } },
		{ title: balanceFieldName, field: 'balance', headerHozAlign: 'center', hozAlign: 'right', width:150, formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", precision:false } },
		{ title: branchFieldName, field: 'branch_name', headerHozAlign: 'center', hozAlign: 'center', width:150 },
		{ title: statusFieldName, field: 'status', headerHozAlign: 'center', hozAlign: 'center', width:160 },
		{ title: overdueDays, field: 'overduedays', headerHozAlign: 'center', hozAlign: 'center', width:160 },
	];
};

// CSV 파일 생성 시 오늘 날짜를 기준으로 파일명을 표기하기 위해서
const csvToday = new Date();

// 대출채권 조회 화면
const Bond001 = () => {
	const { t, i18n }                     = useTranslation();
	const dispatch                        = useDispatch();
	const defaultDate                     = new Date();
    const tableRef                        = useRef(null);

	// 초기 값
	const [loading, setLoading]           = useState(false);
	const [startDate, setStartDate]       = useState(defaultDate.setMonth(defaultDate.getMonth() - 2));
	const [endDate, setEndDate]           = useState(new Date());
	const [expiryStartDate, setExpiryStartDate]       = useState(new Date());
	const [expiryEndDate, setExpiryEndDate]           = useState(defaultDate.setMonth(defaultDate.getMonth() + 36));
	const [customerName, setCustomerName] = useState('');
	// const [rowsPerPage, setRowsPerPage]   = useState(20);
	const [rowsPerPage]   = useState(20);
	const [resultData, setResultData]     = useState([]);
	const [filterField, setFilterField]   = useState('loan_receivable_id');
	const [filterType, setFilterType]     = useState('like');
	const [filterValue, setFilterValue]   = useState('');
	const [totalCount, setTotalCount]                 = useState(0);
	const [startLoanAmt, setStartLoanAmt] = useState(1);
	const [endLoanAmt, setEndLoanAmt] = useState('10.000.000.000');
	
	// .csv 파일에서 column header label을 번역에 맞게 표기하기 위해서
	// 그리고 Tabulator의 컬럼명을 공통적으로 사용하기 위해서
	const loanDateFieldName         = t(`LOAN_RECEIVABLE_INQUIRY.대출일`, { defaultValue: '대출일' });
    const loanReceivableIdFieldName = t(`LOAN_RECEIVABLE_INQUIRY.계약번호`, { defaultValue: '계약번호' });
    const customerNameFieldName     = t(`LOAN_RECEIVABLE_INQUIRY.성명`, { defaultValue: '성명' });
	const collateralType     		= t(`LOAN_APPLICATION.담보물종류`, { defaultValue: '담보물종류' });
    const expiredDateFieldName      = t(`LOAN_RECEIVABLE_INQUIRY.만료일`, { defaultValue: '만료일' });
    const loanAmountFieldName       = t(`LOAN_RECEIVABLE_INQUIRY.대출액`, { defaultValue: '대출액' });
    const balanceFieldName          = t(`LOAN_RECEIVABLE_INQUIRY.대출잔액`, { defaultValue: '대출잔액' });
    const branchFieldName           = t(`COLLECTION_MANAGEMENT.지점`, { defaultValue: '지점' });
    const statusFieldName           = t(`LOAN_RECEIVABLE_INQUIRY.상태`, { defaultValue: '상태' });
    const overdueDaysFieldName      = t(`LOAN_RECEIVABLE_INQUIRY.연체일수`, { defaultValue: '연체일수' });

	const [selectOptions, setSelectOptions]           = useState([]);
	const [columns, setColumns]     = useState(initializeColumns(t, loanDateFieldName, loanReceivableIdFieldName, customerNameFieldName, collateralType, expiredDateFieldName, loanAmountFieldName, balanceFieldName, branchFieldName, statusFieldName,overdueDaysFieldName));

	const headers = [
		{ label: loanDateFieldName,         key: 'loan_disbursement_date' },
		{ label: loanReceivableIdFieldName, key: 'loan_receivable_id' },
		{ label: customerNameFieldName,     key: 'name' },
		{ label: collateralType,     		key: 'collateral_type' },
		{ label: expiredDateFieldName,      key: 'expired_date' },
		{ label: loanAmountFieldName,       key: 'loan_amount' },
		{ label: balanceFieldName,          key: 'balance' },
		{ label: branchFieldName,           key: 'branch_name' },
		{ label: statusFieldName,           key: 'status' },
		{ label: overdueDaysFieldName,     	key: 'overduedays' },
	];

	// remote 방식에 따른 페이징 처리
	const apiUrl                              = API_BASE_URL;
	const userInfo                            = getUserInfo(store.getState());
	// const [branchType, setBranchType]         = useState(userInfo.branch_type);
	const [branchType]         = useState(userInfo.branch_type);
	const token                               = userInfo?.access_token;
	const [selectBranch,setSelectBranch]      = useState('');
	const [selectOptions1,setSelectOptions1]  = useState([]);
	const [selectcollateralType,setSelectcollateralType]      = useState('');

	// 지점 정보 변경
	const handleChangeBranch = (e) => {
		setSelectBranch(e.target.value);
	};
	// 담보물 종류 변경
	const handleCollectralTypeChange = (e) => {
		setSelectcollateralType(e.target.value);
	};

	// ①. 강제로 쿠키 삭제를 통한 로그인 정보가 없는 경우
    const persistInfo = sessionStorage.getItem('persist:login');

    if (!persistInfo) {
        window.location.href = '/login';
    };

	// ②. 토큰 만료 체크 루틴
	if (token) {
		const decodedToken            = jwtDecode(token);
		const expirationTimeInSeconds = decodedToken.exp;
		const currentTimeInSeconds    = Math.floor(Date.now() / 1000);

		if (expirationTimeInSeconds < currentTimeInSeconds) {
			// 토큰이 만료되었을 경우 로그인 페이지로 리디렉션
			dispatch(clearUserState());
			dispatch(clearMenuState());
			dispatch(clearLangCodeState());
			localStorage.removeItem('langCodeInfo');
			window.location.href = '/login';
		};
	};
	const FileDetails = ({ children }) => (
		<div className="file-details col d-flex justify-content-center align-items-center" style={{ overflow: 'hidden' }}>
			{children}
		</div>
	);
	// i18 선택된 언어에 따라 필요한 필드 값 번역
	const translateItem = useCallback((item, language) => ({
		...item,
		status: t(`LOAN_RECEIVABLE_STATUS.${item.status}`, { lng: language }),
		collateral_type         : item.collateral_type ? t(`COLLATERAL.${item.collateral_type}`, { lng: language }) : '',
	}), [t]);

	// 오늘 버튼 액션
	// const handleChangeTodayDate = () => {
	// 	setStartDate(new Date());
	// };

	// 어제 버튼 액션
	const handleChangeYesterDayDate = () => {
		const today     = new Date();
		const yesterday = new Date(today.setDate(today.getDate() - 1));
		setStartDate(yesterday);
	};

	// 이번달 버튼 액션
	const handleChangeMonthDate = () => {
		const today       = new Date();
		// const oneMonthAgo = today.setMonth(today.getMonth() - 1);
		// setStartDate(oneMonthAgo);
		const firstDayOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		setStartDate(firstDayOfThisMonth);
		setEndDate(new Date());
	};

	// 시작일 값 변경
	const handleChangeStartDate = (date) => {
		setStartDate(date);
		console.log('0 StartDate : ' + startDate);
	};

	// 종료일 값 변경
	const handleChangeEndDate = (date) => {
		setEndDate(date);
	};
	// 대출 만료일 시작일  변경
	const handleChangeExpiryStartDate = (date) => {
		setExpiryStartDate(date);
		console.log('0 expiryStartDate : ' + expiryStartDate);
	};

	// 대출 만료일  종료일 값 변경
	const handleChangeExpiryEndDate = (date) => {
		setExpiryEndDate(date);
	};

	// 성명 변경
	const handleChangeCustomerName = (e) => {
		setCustomerName(e.target.value);
	};

	// 대출 잔액 시작금액 변경
	const handleChangeStartLoanAmt = (e) => {
		let value = e.target.value.replace(/\D/g, ''); // 모든 비숫자 문자를 제거
		// setStartLoanAmt(value);
		setStartLoanAmt(formatCurrency(value));
	};
	const formatCurrency = (value) => {
		if (!value) return '';
		const number = parseInt(value, 10);
		return number.toLocaleString('vi-VN');
	  };
	// 대출 잔액 종료금액 변경
	const handleChangeEndLoanAmt = (e) => {
		// setEndLoanAmt(e.target.value);
		let value = e.target.value.replace(/\D/g, ''); // 모든 비숫자 문자를 제거
		setEndLoanAmt(formatCurrency(value));
	};

	// 접수 채널 선택 옵션
	const fetchBaseOptions = async () => {			
		try {
			const data = await API.fetchBaseOptions();
			
			const options1      = data.filter(item => item.code_nick_name === '지점');
			const SelectOptions = options1.map(item => [item.code,item.code_se]);

			setSelectOptions1(SelectOptions);	

			const options  = data.filter(item => item.code_nick_name === '담보물종류');
			const result   = options.flatMap(item => item.code);

			setSelectOptions(result);


			if (SelectOptions.length === 1) {
				setSelectBranch(SelectOptions[0][0]);
			};

		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Tabulator Options
	// options 객체를 상태로 관리
	const [options, setOptions] = useState({
		ajaxURL     : `${apiUrl}/bond/bond_001`,
		ajaxConfig  : {
			method  : 'GET',
			headers : {
				'Content-Type' : 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		},
		ajaxParams : {
			startDate    : moment(startDate).format('YYYY-MM-DD'),
			endDate      : moment(endDate).format('YYYY-MM-DD'),
			customerName : customerName,
			expiryStartDate : moment(expiryStartDate).format('YYYY-MM-DD'),
			expiryEndDate   : moment(expiryEndDate).format('YYYY-MM-DD'),
			startLoanAmt : startLoanAmt,
			endLoanAmt   : endLoanAmt,
			branch_code  : selectBranch,
			page         : tableRef.current && tableRef.current.table ? tableRef.current.getPage() : 1,
			size         : tableRef.current && tableRef.current.table ? tableRef.current.getPageSize() : 20, // 페이지 크기 정보
		},
		layout                 : "fitColumns",
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage,
		paginationSizeSelector : [20, 40, 60, 80, 100],
		ajaxResponse : function (url, params, response) {

			// 값이 변경되면 직접 타이핑 하는 성명 칸은 초기화시키기
			// setCustomerName('');
			const total_count    = response.total_count || 0;
			const translatedData = response.data.map(item => translateItem(item, i18n.language));
			const responseData   = {
				last_page : response.last_page,
				data      : translatedData,
			};

			setResultData(responseData.data);
			setTotalCount(total_count);

			return responseData;
		}
	});

	// 로딩 중일 때 이전의 pagination 관련 정보를 유지하도록 설정
	const loadingOptions = {
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage, // 이전 페이지 사이즈를 유지
		paginationSizeSelector : [20, 40, 60, 80, 100],
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = useCallback(
		async () => {
			setLoading(true);

			// ReactTabulator의 내부 로직을 사용하여 API 호출
			try {
				// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
			
				const url  = new URL(options.ajaxURL);
				url.search = new URLSearchParams({
					...options.ajaxParams,
					customerName : customerName,
					startLoanAmt         : startLoanAmt,
					endLoanAmt           : endLoanAmt,
					page         : tableRef.current?.getPage(),     // 현재 페이지 정보
					size         : tableRef.current?.getPageSize(), // 페이지 크기 정보
				});

				const data = await fetch(url, {
					method  : options.ajaxConfig.method,
					headers : options.ajaxConfig.headers,
				});

				const responseData = await data.json();

				// 전달 받은 총 데이터 건수
				const total_count = responseData.total_count || 0;
		
				// 번역이 필요한 부분
				const translatedData = responseData.data.map(item => translateItem(item, i18n.language));
		
				// 페이징 및 데이터 리턴
				const updatedData = {
					last_page : responseData.last_page, // 전체 페이지 수 계산
					data      : translatedData, // 실제 테이블 데이터
				};

				// 총 건수를 화면에 표현하기 위해서
				setTotalCount(total_count);

				// 데이터 변경
				if (tableRef.current) {
					setResultData(updatedData.data);
					tableRef.current.setData(updatedData.data || []);
				}

				setLoading(false);

			} catch (error) {
				console.error('Error in fetchBond001Data : ', error);
				setLoading(false);
			} 
		}, [options,  customerName,startLoanAmt, endLoanAmt, i18n.language, translateItem]
	);

	// 조회 조건이 바뀜에 따라 ajaxParams 동적 변경
	useEffect(() => {
		
		setOptions((prevOptions) => {
			const updatedOptions = {
				...prevOptions,
				ajaxParams: {
					...prevOptions.ajaxParams,
					startDate               : moment(startDate).format('YYYY-MM-DD'),
					endDate                 : moment(endDate).format('YYYY-MM-DD'),
					collateralType    		: selectcollateralType,
					startLoanAmt         	: startLoanAmt,
					endLoanAmt           	: endLoanAmt,
					expiryStartDate         : moment(expiryStartDate).format('YYYY-MM-DD'),
					expiryEndDate           : moment(expiryEndDate).format('YYYY-MM-DD'),
					branch_code             : selectBranch
				},
			};
			return updatedOptions;
		});
	}, [startDate, endDate, selectBranch,selectcollateralType,expiryStartDate,expiryEndDate]);

	// i18 언어에 맞춰서 자동 갱신 (컬럼명, Grid 내용)
	useEffect(() => {
		setColumns(initializeColumns(t, loanDateFieldName, loanReceivableIdFieldName, customerNameFieldName, collateralType, expiredDateFieldName, loanAmountFieldName, balanceFieldName, branchFieldName, statusFieldName,overdueDaysFieldName));
	}, [i18n.language, t, loanDateFieldName, loanReceivableIdFieldName, customerNameFieldName, collateralType, expiredDateFieldName, loanAmountFieldName, balanceFieldName, branchFieldName, statusFieldName,overdueDaysFieldName, handleQuery]);

	// Filter 값에 따른 Tabulator 변화가 일어나는 함수
	const updateFilter = () => {
		if (tableRef.current) {
			const filteredValue = filterField === 'loan_receivable_id' ? filterValue.replace(/-/g, '') : filterValue;
			tableRef.current.setFilter(filterField, filterType, filteredValue);
		}
	};

	// 선택 조건 불러오기
	useEffect(() => {
		fetchBaseOptions();
	}, []);

	// value값을 입력할 때마다 해당되는 Tabulator가 화면에 보이도록 함수호출하는 부분
	const handleKeyUp = () => {
		updateFilter();
	};

	// 화면 UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t(`LOAN_RECEIVABLE_INQUIRY.대출채권 조회/관리`, { defaultValue: '대출채권 조회/관리' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
			<div className="panel-body">
				<div className="row ms-2">
					<div className="form-group col-lg-4 col-md-12 col-xs-12 mb-2 ps-0 pe-2 rounded-2 display: flex;">
						<label className="form-label" htmlFor="date_id">
							<i className="bi bi-calendar3 "></i> {t(`LOAN_RECEIVABLE_INQUIRY.대출일`, { defaultValue: '대출일' })}
						</label>
					
						<div className="input-group input-daterange d-flex align-items-center mb-1">
							<div className='col'>
								<DatePicker
									className='form-control'
									selected={startDate}
									onChange={handleChangeStartDate}
									dateFormat="dd/MM/yyyy"
								/>
							</div>

							<div className="col-auto">
								<span className="input-group-text input-group-addon"> ~ </span>
							</div>

							<div className='col'>
								<DatePicker
									className='form-control'
									selected={endDate}
									onChange={handleChangeEndDate}
									dateFormat="dd/MM/yyyy"
								/>
							</div>

							<div className="mb-0 ms-2">
								<button type="button" className="btn btn-success btn-xs me-1 w-80px m-2" onClick={handleChangeYesterDayDate}>{t('LOAN_APPLICATION.어제', { defaultValue: '어제' })}</button>
								<button type="button" className="btn btn-success btn-xs w-80px" onClick={handleChangeMonthDate}>{t('LOAN_APPLICATION.이번달', { defaultValue: '이번달' })}</button>
								{/* <button type="button" className="btn btn-success btn-xs w-80px" onClick={handleChangeMonthDate}>{t('LOAN_APPLICATION.이번달', { defaultValue: '이번달' })}</button> */}
								{/* <button type="button" className="btn btn-success btn-xs w-80px" onClick={handleChangeMonthDate}>{t('LOAN_APPLICATION.이번달', { defaultValue: '이번달' })}</button> */}
							</div> 
						</div>
						<div className="form-group col-lg-4 col-md-8 col-xs-8 mb-2 ps-0 pe-2 rounded-2 display: flex;">
							<div className="me-1">
								<label className="form-label" htmlFor="before_loan_amount">
									<i className="bi bi-pen"></i> {t('LOAN_RECEIVABLE_INQUIRY.대출잔액', { defaultValue: '대출잔액' })}
								</label>

								<div className="d-flex align-items-center">
									<input className="form-control col-sm-2" type="text" id="start_loan_amount" placeholder={t('LOAN_RECEIVABLE_INQUIRY.대출잔액', { defaultValue: '대출잔액' })} onChange={handleChangeStartLoanAmt} value={startLoanAmt} style={{ textAlign: 'right' }}/>
									<div className="col-auto">
										<span className="input-group-text input-group-addon"> ~ </span>
									</div>

									<input className="form-control col-sm-2" type="text" id="end_loan_amount" placeholder={t('LOAN_RECEIVABLE_INQUIRY.대출잔액', { defaultValue: '대출잔액' })} onChange={handleChangeEndLoanAmt}  value={endLoanAmt} style={{ textAlign: 'right' }}/>
								</div>
							</div>
						</div>
					</div>

					<div className="form-group col-lg-3 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
						<label className="form-label" htmlFor="expiry_date_id">
							<i className="bi bi-calendar3"></i> {t(`LOAN_RECEIVABLE_INQUIRY.만료일`, { defaultValue: '만료일' })}
						</label>

						<div className="input-group input-daterange d-flex align-items-center">
							<div className='col'>
								<DatePicker
									className='form-control'
									selected={expiryStartDate}
									onChange={handleChangeExpiryStartDate}
									dateFormat="dd/MM/yyyy"
								/>
							</div>

							<div className="col-auto">
								<span className="input-group-text input-group-addon"> ~ </span>
							</div>

							<div className='col'>
								<DatePicker
									className='form-control'
									selected={expiryEndDate}
									onChange={handleChangeExpiryEndDate}
									dateFormat="dd/MM/yyyy"
								/>
							</div>
						</div>
					</div>
					<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 pe-2 rounded-2 display: flex;">
						<label className="form-label" htmlFor="collateral_type">
							<i className="bi bi-pen"></i> {t('LOAN_APPLICATION.담보물종류', { defaultValue: '담보물종류' })}
						</label>
						<FileDetails style={{ width: '50%' }}>
							<select className="form-select form-select-sm" value={selectcollateralType} onChange={handleCollectralTypeChange} style={{ fontSize: '14px' }}>
								{ <option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
								}
								{selectOptions.map((option, index) => (
									<option key={index} value={option}>
										{t(`COLLATERAL.${option}`, { defaultValue: `${option}` })}
									</option>
								))}
							</select>
						</FileDetails>
					</div>
					<div className="form-group col-lg-1 col-md-12 col-xs-12 mb-2 ps-0 pe-2 rounded-2 display: flex;">
						<label className="form-label" htmlFor="acct_nickname_id">
							<i className="bi bi-pen"></i> {t('LOAN_APPLICATION.성명', { defaultValue: '성명' })}
						</label>
						<input className="form-control" type="text" id="acct_nickname_id" placeholder={t('LOAN_APPLICATION.성명', { defaultValue: '성명' })} onChange={handleChangeCustomerName} />
					</div>
					<div className="form-group col-lg-1 col-md-12 col-xs-12 mb-2 ps-0 pe-2 rounded-2 display: flex;">
							<label className="form-label" htmlFor="acct_nickname_id">
								<i className="bi bi-pen"></i> {t('LOAN_APPLICATION.지점', { defaultValue: '지점' })}
							</label>
							<select onChange={handleChangeBranch} value={selectBranch} className="form-select" id="site_code_id">
								{branchType === 'HEAD'
									? <option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
									: ''
								}
								{selectOptions1.map((option, index) => (
									<option key={index} value={option[0]}>
										{option[1]}                                            
									</option>
								))}
							</select>
						</div>
					<div className="form-group col-lg-1 col-md-12 col-xs-12 mb-2 ps-0 pe-2 rounded-2 display: flex;">
						<div className="mb-3"></div>
						<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
						
						<div className="form-group col-lg-5 col-md-12 col-xs-12 mb-2 ps-0 pe-2 rounded-2">
							<div className="d-flex align-items-start">
							</div>
						</div>
					</div>

					<div className="mt-3 mb-3 ps-0">
						<i id="filter-icon" className="cursor-pointer fa fa-plus-square" data-bs-toggle="collapse" href="#collapseExample" aria-expanded="true" aria-controls="collapseExample"></i>
						<span> Filter</span>
					</div>

					<div className="collapse show" id="collapseExample">
						<div className="row">
							<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
								<select 
									id="filter-field" 
									className="form-select col-sm-3" 
									value={filterField}
									onChange={(e) => setFilterField(e.target.value)}
								>
									<option value="loan_receivable_id">{t(`LOAN_RECEIVABLE_INQUIRY.계약번호`, { defaultValue: '계약번호' })}</option>
									<option value="name">{t(`LOAN_RECEIVABLE_INQUIRY.성명`, { defaultValue: '성명' })}</option>
									<option value="status">{t(`LOAN_RECEIVABLE_INQUIRY.상태`, { defaultValue: '상태' })}</option>
								</select>
							</div>
				
							<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
								<select 
									id="filter-type" 
									className="form-select col-sm-3"
									value={filterType}
									onChange={(e) => setFilterType(e.target.value)}
								>
									<option value="like">LIKE</option>
									<option value="=">=</option>
									<option value="<">&lt;</option>
									<option value="<=">&le;</option>
									<option value=">">&gt;</option>
									<option value=">=">&ge;</option>
									<option value="!=">!=</option>
								</select>
							</div>
				
							<div className="form-group col-lg-8 col-md-12 col-xs-12 ps-0  mb-3 rounded-2">
								<input 
									id="filter-value" 
									type="text" 
									className="form-control col-sm-6" 
									name="filter-value" 
									placeholder={t(`COMMON.검색할 내용을 입력하세요`, { defaultValue: '검색할 내용을 입력하세요' })}
									value={filterValue}
									onChange={(e) => setFilterValue(e.target.value)}
									onKeyUp={handleKeyUp}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>


				{/* 로딩 관련 gif */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}

				{/* Tabulator */}
				<div id="tabulator-total-info" className='d-flex justify-content-end fw-bold'>{t(`LOAN_APPLICATION.총 {{count}}건`, { count: totalCount, defaultValue: '총 {{count}}건' })}</div>
				<ReactTabulator
					key         = {i18n.language + JSON.stringify(columns) + JSON.stringify(options)} // 언어 변경 및 옵션 변경에 따라 컴포넌트 리렌더링
					onRef       = {(r) => (tableRef.current = r.current)}
					columns     = {columns}
					options     = {loading ? loadingOptions : options} // 로딩 중일 때는 이전의 pagination 관련 정보를 유지하고 데이터를 변경하지 않도록 함
					placeholder = "No Data Found"
					className   = "responsive-tabulator"
				/>
			</Card.Body>

			<div className="card-footer d-flex justify-content-start mt-auto">
				<Link to={'/loan/loan_002'}>
					<button type="button" className="btn btn-outline-info mb-1 me-1 w-auto">{t(`LOAN_APPLICATION.대출신청`, { defaultValue: '대출신청' })}</button>
				</Link>

				{/* <button type="button" className="btn btn-outline-success me-1 mb-1 w-auto">{t(`LOAN_RECEIVABLE_INQUIRY.프린트`, { defaultValue: '프린트' })}</button> */}

				{/* CSV 내보내기 시에 포맷을 다시 적용해서 날짜 형식이 변환된 값으로 .csv를 만든다. */}
				<CSVLink 
					data={resultData.map((row) => {
						// 로그를 여기서 찍습니다.
						return {
							loan_disbursement_date : moment(row.loan_disbursement_date).format('DD/MM/YYYY'),
							loan_receivable_id     : row.loan_receivable_id,
							name                   : row.name,
							collateral_type        : row.collateral_type,
							expired_date           : moment(row.expired_date).format('DD/MM/YYYY'),
							loan_amount            : row.loan_amount,
							balance                : row.balance,
							branch_name            : row.branch_name,
							status                 : row.status,
							overduedays            : row.overduedays
						};
					})}
					/*
					data={resultData.map((row) => ({
						loan_disbursement_date : moment(row.loan_disbursement_date).format('DD/MM/YYYY'),
						loan_receivable_id     : row.loan_receivable_id,
						name                   : row.name,
						collateral_type         : row.collateral_type,
						expired_date           : moment(row.expired_date).format('DD/MM/YYYY'),
						loan_amount            : row.loan_amount,
						balance                : row.balance,
						branch_name            : row.branch_name,
						status                 : row.status,
						overdueDays            : row.overdueDays
					}))}*/
					headers={headers}
					filename={'Receivable_' + moment(csvToday).format('DD-MM-YYYY') + '.csv'}
					className="btn btn-outline-success me-1 mb-1 w-auto"
				>
					{t(`REPORT.다운로드`, { defaultValue: '다운로드' })}
				</CSVLink>
			</div>
		</ Card>
	);
};

export default Bond001;